import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=3b2d6ada&scoped=true"
import script from "./ReCaptcha.vue?vue&type=script&lang=js"
export * from "./ReCaptcha.vue?vue&type=script&lang=js"
import style0 from "./ReCaptcha.vue?vue&type=style&index=0&id=3b2d6ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2d6ada",
  null
  
)

export default component.exports